import React from "react";
import Button from "./Button";
import ExportIcon from "../assets/img/manage_data/data_upload.svg";

interface ExportActionButtonProps {
  disabled?: boolean;
  isLoading?: boolean;
  loadingLabel?: string;
  onClick: () => void | Promise<void>;
}

const ExportActionButton: React.FunctionComponent<ExportActionButtonProps> = ({
  disabled = false,
  isLoading = false,
  loadingLabel = "Exporting...",
  onClick,
}) => {
  return (
    <Button
      disabled={disabled || isLoading}
      className="export-button"
      onClick={onClick}
      style={{ height: "100%" }}
    >
      {isLoading ? (
        <span className="export-button__content">
          <span className="export-button__spinner" aria-hidden="true" />
          <span>{loadingLabel}</span>
        </span>
      ) : (
        <>
          <img
            src={ExportIcon}
            alt="Export Icon"
            className="export-icon"
          />
          <span>Export Table</span>
        </>
      )}
    </Button>
  );
};

export default ExportActionButton;